import { PaymentOption } from '../../helpers/utils/types';

export const formatDate = (isoDate?: string) => {
  if (!isoDate) return '--';
  const parsed = new Date(isoDate);
  if (Number.isNaN(parsed.getTime())) return '--';
  // Use UTC getters, not toLocaleDateString, so the displayed calendar day
  // matches the API's date regardless of the viewer's timezone (TEN-2379).
  const year = parsed.getUTCFullYear();
  const month = String(parsed.getUTCMonth() + 1).padStart(2, '0');
  const day = String(parsed.getUTCDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const getPaymentBadge = (method: PaymentOption) => {
  if (method.paymentMethod?.toLowerCase() === 'preauthorizeddebit') return 'BANK';
  if (method.cardBrand?.toLowerCase().includes('master')) return 'MC';
  return 'VISA';
};

export const getPaymentDisplayName = (method: PaymentOption) =>
  (method.paymentMethod?.toLowerCase() === 'preauthorizeddebit'
    ? 'PAD'
    : method.cardBrand || method.paymentMethod || 'Method'
  )
    .replace(/([A-Z])/g, ' $1')
    .trim();
